import React from "react";
import tinycolor from "tinycolor2";
import "./colors.scss";

export const isDark = (color: string): boolean => tinycolor(color).isDark();

export const GradientDefinitions: React.FC = () => (
  <svg className="GradientDefinitions" aria-hidden="true" focusable="false">
    <linearGradient id="azure_500" x1="-0.527693" y1="12.4467" x2="33.011" y2="20.1948" gradientUnits="userSpaceOnUse">
      <stop stopColor="#00C2FF" />
      <stop offset="1" stopColor="#245AE3" />
    </linearGradient>
  </svg>
);

export default isDark;
